/**
 * Strip 6-digit Indian pincode and trailing "India" / country from a formatted address.
 * e.g. "CONCORD, Sector 143, Noida, Uttar Pradesh 201301, India"
 *   -> "CONCORD, Sector 143, Noida, Uttar Pradesh"
 */
export const stripPincodeAndCountry = (addr) => {
  if (!addr) return '';
  return addr
    .replace(/\s*\d{6}\b/g, '')
    .replace(/,?\s*India\s*$/i, '')
    .replace(/,\s*$/, '')
    .trim();
};

/**
 * Google reverse geocode — returns formatted_address without pincode.
 * Region-biased to India.
 */
export const reverseGeocodeLatLng = async (lat, lng, apiKey) => {
  if (!apiKey) return null;
  try {
    const url = new URL('https://maps.googleapis.com/maps/api/geocode/json');
    url.searchParams.set('latlng', `${lat},${lng}`);
    url.searchParams.set('key', apiKey);
    url.searchParams.set('region', 'in');
    url.searchParams.set('language', 'en');
    const res = await fetch(url.toString());
    const data = await res.json();
    if (data.status !== 'OK' || !data.results?.length) return null;

    const fmt = data.results[0].formatted_address;
    return stripPincodeAndCountry(fmt) || null;
  } catch {
    return null;
  }
};

/**
 * Google forward geocode — restricted to India via component filtering.
 */
export const forwardGeocodeQuery = async (query, apiKey) => {
  if (!apiKey) return [];
  try {
    const url = new URL('https://maps.googleapis.com/maps/api/geocode/json');
    url.searchParams.set('address', query);
    url.searchParams.set('key', apiKey);
    url.searchParams.set('region', 'in');
    url.searchParams.set('components', 'country:IN');
    url.searchParams.set('language', 'en');
    const res = await fetch(url.toString());
    const data = await res.json();
    if (data.status !== 'OK' || !data.results?.length) return [];
    return data.results.map((r) => ({
      lat: r.geometry.location.lat,
      lng: r.geometry.location.lng,
      name: stripPincodeAndCountry(r.formatted_address),
    }));
  } catch {
    return [];
  }
};
